




















































































































































































































import { Vue, Component } from "vue-property-decorator";
import { Video as IVideo } from "@/api/models/video";
import { User as IUser } from "@/api/models/user";
import { Company as ICompany } from "@/api/models/company";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import SearchUser from "@/components/user/SearchUser.vue";
import { UsersList as IUsersList } from "@/api/models/users-list";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";

@Component({
  components: {
    TextField,
    CBlock,
    CBreadCrumbs,
    CustomButton,
    SearchUser,
    CustomTableCol,
    CustomTableItem,
    CustomTable
  }
})
export default class recordView extends Vue {
  video!: IVideo;
  ownerInfo!: IUser;
  companyInfo!: ICompany;
  viewersList: Array<IUser> = [];
  viewersCount: number | undefined = 0;
  showSpinner: boolean = false;
  limit: number = 30;
  offset: number = 0;

  data() {
    return {
      video: undefined,
      ownerInfo: undefined,
      companyInfo: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "records" },
        label: this.$tc(this.$translate.Records)
      },
      {
        label: this.video.title
      }
    ];
  }

  get thirdPartyResourceVideoUrl() {
    return this.video?.url?.includes("iframe");
  }

  get grantedForComponent() {
    return this.root || this.contentManager || this.companyOwner;
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get contentManager() {
    return this.$store.getters.roles.includes("content_manager");
  }

  get videoOwner() {
    return this.ownerInfo && this.ownerInfo.id === this.userId;
  }

  getUserInfo() {
    api.UsersApi.get(this.video.ownerId).then((response: { data: IUser }) => {
      this.ownerInfo = response.data;
    });
  }

  getRecordViewers(offset: number = 0) {
    if (this.video && this.grantedForComponent) {
      this.showSpinner = true;
      api.VideoApi.getViewers(this.video.id, offset, this.limit)
        .then((res: { data: IUsersList }) => {
          this.viewersCount = res.data.count;
          res.data.users?.forEach((user: IUser) => {
            this.viewersList.push(user);
          });
        })
        .finally(() => {
          this.showSpinner = false;
        });
    }
  }

  deleteViewer(user: IUser) {
    if (!this.video) {
      this.viewersList = this.viewersList?.filter(element => {
        return element !== user;
      });
    } else {
      api.VideoApi.removeViewers(this.video.id, [user.id]).then(() => {
        this.viewersList = [];
        this.$bvToast.toast(
          `${this.$tc(
            this.$translate.UserSuccessfullyDisconnectedFromTheVideo
          )}`,
          {
            variant: "success",
            title: this.$tc(this.$translate.Successful)
          }
        );
        this.getRecordViewers();
      });
    }
  }

  addViewer(item: IUser) {
    if (!this.video) {
      this.viewersList?.push(item);
    } else {
      api.VideoApi.addViewers(this.video.id, [item.id])
        .then(() => {
          this.viewersList = [];
          this.$bvToast.toast(
            `${this.$tc(this.$translate.UserSuccessfullyAddedToVideo)}`,
            {
              variant: "success",
              title: this.$tc(this.$translate.Successful)
            }
          );
          this.getRecordViewers();
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  getCompanyInfo() {
    api.CompanyApi.get(this.video.companyId)
      .then((response: { data: ICompany }) => {
        this.companyInfo = response.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  showMore() {
    this.offset += this.limit;
    this.getRecordViewers(this.offset);
  }

  created() {
    api.VideoApi.get(this.$route.params.id)
      .then((res: { data: IVideo }) => {
        this.video = res.data;
        document.title = this.video.title;
        this.getUserInfo();
        this.getCompanyInfo();
        this.getRecordViewers();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }
}
